const DEFAULT_COLUMN_LIMIT = 20

/**
 * ExcelJS cell values are not always strings: shared formulas, rich text and hyperlinks
 * arrive as objects.
 */
export function readCellText(value) {
  if (value === null || value === undefined) {
    return ''
  }

  if (value instanceof Date) {
    return value.toISOString()
  }

  if (typeof value === 'object') {
    if (Array.isArray(value.richText)) {
      return value.richText.map(part => part.text).join('')
    }
    if (value.text !== undefined) {
      return String(value.text)
    }
    if (value.result !== undefined) {
      return String(value.result)
    }
    return ''
  }

  return String(value)
}

export function readCell(row, column) {
  if (!column) {
    return ''
  }
  return readCellText(row.getCell(column).value).trim()
}

export function normalizeHeaderText(value) {
  return readCellText(value).replace(/\s+/g, ' ').trim().toLowerCase()
}

/**
 * Maps the normalized header text of a row to the column it sits in, so a format can find its
 * columns by name instead of assuming positions. First occurrence wins for repeated headers.
 */
export function findHeaderColumns(row, columnLimit = DEFAULT_COLUMN_LIMIT) {
  const columnsByHeader = {}

  for (let column = 1; column <= columnLimit; column += 1) {
    const header = normalizeHeaderText(row.getCell(column).value)

    if (header && !columnsByHeader[header]) {
      columnsByHeader[header] = column
    }
  }

  return columnsByHeader
}
